import React, { useState, useEffect } from "react";
import * as R from "ramda";
import "./CustomerOrdersMobile.scss";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";

import { Order } from "types/Order";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IconButton } from "@material-ui/core";
import TableCellText from "common/components/TableCellText/TableCellText";
import CheckBox from "components/CheckBox";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import EditIcon from "@material-ui/icons/Edit";
import { OrderCustomerDetails } from "types/OrderCustomerDetails";
type OrdersMobileProps = {
  order: OrderCustomerDetails;
  clickedOnPaid?: any;
  clickedOnDelivered?: any;
  clickedOnOrdered?: any;
  onOpenOrder?: any;
  onOpenReminder?: any;
  onEdit?: any;
  onDelete?: any;
};

const CustomerOrdersMobile: React.FC<OrdersMobileProps> = ({
  order,
  clickedOnPaid,
  clickedOnDelivered,
  clickedOnOrdered,
  onOpenOrder,
  onOpenReminder,
  onEdit,
  onDelete,
}) => {
  function dateData() {
    const date = new Date(order.createdDate);
    return (
      <div className="me-2">
        {/* order-mobile-date-container */}
        <strong>
          <div>
            {date.getDate()}/{date.getMonth()}
          </div>
        </strong>
      </div>
    );
  }
  return (
    <div className="order-mobile-row">
      <div className="order-mobile-section flex-grow-1">
        <div className="d-flex flex-column flex-grow-1 ms-3 ">
          <div className="d-flex flex-row flex-grow-1 align-content-center fs-3">
            {dateData()}

            <div className="d-flex flex-row flex-grow-1 align-content-end">
              <p className="w-100 text-center fw-bold">
                Pris: {order.totalPrice} kr
              </p>
            </div>
          </div>
          <div className="d-flex flex-row flex-grow-1 mt-2">
            <div className="order-checkbox me-3 ">
              <h3 style={{ fontWeight: 600, fontSize: 16, marginBottom: 0 }}>
                Bestilt
              </h3>
              <CheckBox
                checked={order.orderedFromSupplier}
                onChange={(e: any) =>
                  clickedOnOrdered(order.id, e.target.checked)
                }
              />
            </div>
            <div className="order-checkbox me-3">
              <h3 style={{ fontWeight: 600, fontSize: 16, marginBottom: 0 }}>
                Levert
              </h3>
              <CheckBox
                checked={order.delivered}
                onChange={(e: any) =>
                  clickedOnDelivered(order.id, e.target.checked)
                }
              />
            </div>
            <div className="order-checkbox">
              <h3 style={{ fontWeight: 600, fontSize: 16, marginBottom: 0 }}>
                Betalt
              </h3>
              <CheckBox
                checked={order.paid}
                onChange={(e: any) => clickedOnPaid(order.id, e.target.checked)}
              />
            </div>
          </div>
        </div>
        <div className="order-mobile-section-content" style={{ width: 120 }}>
          <div className="d-flex flex-column flex-grow-1">
            <div className="d-flex flex-row flex-grow-1 mb-2">
              <div className="me-2">
                <OverlayTrigger
                  key="top"
                  placement="top"
                  overlay={
                    <Tooltip id="customer-tooltip" style={{ zIndex: 1301 }}>
                      Se info
                    </Tooltip>
                  }
                >
                  <IconButton
                    style={{
                      color: "#906088",
                    }}
                    onClick={() => onOpenOrder(order)}
                  >
                    <InfoIcon />
                  </IconButton>
                </OverlayTrigger>
              </div>
              <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                  <Tooltip id="customer-tooltip" style={{ zIndex: 1301 }}>
                    Påminnelse
                  </Tooltip>
                }
              >
                <IconButton
                  style={{
                    color: "#906088",
                  }}
                  onClick={() => onOpenReminder(order)}
                >
                  <NotificationsNoneIcon />
                </IconButton>
              </OverlayTrigger>
            </div>
            <div className="d-flex flex-row flex-grow-1 mb-2">
              <div className="me-2">
                <OverlayTrigger
                  key="top"
                  placement="top"
                  overlay={
                    <Tooltip id="customer-tooltip" style={{ zIndex: 1301 }}>
                      Rediger kunde
                    </Tooltip>
                  }
                >
                  <IconButton
                    style={{
                      color: "#906088",
                    }}
                    onClick={() => onEdit(order.id)}
                  >
                    <EditIcon />
                  </IconButton>
                </OverlayTrigger>
              </div>
              <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                  <Tooltip id="customer-tooltip" style={{ zIndex: 1301 }}>
                    Slett
                  </Tooltip>
                }
              >
                <IconButton
                  style={{
                    color: "#906088",
                  }}
                  onClick={() => onDelete(order)}
                >
                  <DeleteIcon />
                </IconButton>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerOrdersMobile;
